import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import TableSkeleton from "components/skeletons/TableSkeleton";
import TablePagination from "components/tablePagination";
import MainTableRow from "./MainTableRow";

const MainTable = ({
  handleDelete,
  pagination,
  setPagination,
  loading,
  setReload,
  allPost,
  setAllPost,
  permissions,
  handleTableCheckBox,
  selectedRows,
}) => {
  const rows = allPost;

  const columns = [
    { id: "name", label: "Title" },
    {
      id: "description",
      label: "Description",
      style: {
        width: "190px",
      },
    },
    {
      id: "knowledge_base_category_name",
      label: "Category",
      minWidth: 150,
    },
    { id: "status", label: "Status" },
    {
      id: "created_by_image",
      label: "Created By",
      align: "center",
      style: { width: "120px" },
    },
    { id: "created_at", label: "Created At" },

    {
      id: "action",
      label: "Actions",
      style: { width: "170px" },
      align: "center",
    },
  ];

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", boxShadow: "none" }}>
      {!loading ? (
        <TableContainer
          sx={{ height: "calc(100vh - 257px)", overflowX: "auto" }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow
                sx={{
                  "& .MuiTableCell-sizeMedium": {
                    padding: "10px 0px 10px 16px",
                  },
                  "& .MuiTableCell-sizeMedium:first-of-type": {
                    paddingLeft: "8px",
                    paddingRight: "0px",
                  },
                }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={
                      selectedRows?.length === allPost?.length &&
                      allPost?.length
                    }
                    onChange={(e) =>
                      handleTableCheckBox("all", e.target.checked)
                    }
                  />
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={column.style}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row) => (
                <MainTableRow
                  key={row.id}
                  row={row}
                  columns={columns}
                  span={columns?.length}
                  handleDelete={handleDelete}
                  setReload={setReload}
                  allPost={allPost}
                  handleTableCheckBox={handleTableCheckBox}
                  selectedRows={selectedRows}
                  setAllPost={setAllPost}
                  permissions={permissions}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableSkeleton columns={columns} tableHeight="calc(100vh - 257px)" />
      )}
      <TablePagination
        span={columns?.length}
        setReload={setReload}
        pagination={pagination}
        setPagination={setPagination}
      />
    </Paper>
  );
};

export default MainTable;
